import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import "./FoodSectionTitle.scss";

interface Props {
    title: string;
}

/** Section heading with the gradient rule, e.g. "Menu: Taco". Children (e.g. tabs) go after the rule. */
const FoodSectionTitle: FCX<Props> = ({ title, className, testId, children }) => (
    <div className={cn("FoodSectionTitle", className)} data-testid={testId}>
        <h2 className="FoodSectionTitle__title">{title}</h2>
        <div className="FoodSectionTitle__line"/>
        {children}
    </div>
);

export default FoodSectionTitle;
